import { Link, useParams } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ChevronLeft } from 'lucide-react';
import { de } from '../../lib/i18n/de';
import { useWizardAudience } from './WizardAudienceContext';

interface WizardLayoutProps {
  children: ReactNode;
  /**
   * Wer schaut sich das an? Wenn nicht gesetzt, kommt der Wert aus dem
   * <WizardAudienceProvider>-Context (Default 'berater').
   */
  audience?: 'berater' | 'mandant';
}

/**
 * Schmaler Wizard-Container (max-w-3xl, identische Breite wie der Hub) plus
 * Brotkrumen-Navigation zurück zur Hub-Übersicht. Der eigentliche Step-Inhalt
 * (Header, Body, Footer-Buttons) lebt in <WizardStep>.
 */
export function WizardLayout({ children, audience: audienceProp }: WizardLayoutProps) {
  const audienceFromContext = useWizardAudience();
  const audience = audienceProp ?? audienceFromContext;
  const { id: caseId = 'demo' } = useParams<{ id: string }>();
  const backTo = audience === 'mandant' ? `/mandant/case/${caseId}` : `/case/${caseId}/hub`;
  const backLabel =
    audience === 'mandant' ? de.mandant.wizard.breadcrumbBack : de.wizard.breadcrumbBack;

  return (
    <div className="pb-24 pt-8 md:pt-12">
      <Link
        to={backTo}
        className="inline-flex items-center gap-1.5 font-sans text-xs font-medium uppercase tracking-widest text-stone-500 hover:text-stone-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-2"
      >
        <ChevronLeft size={14} aria-hidden="true" />
        {backLabel}
      </Link>
      <div className="mt-6">{children}</div>
    </div>
  );
}
